import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import LoggedSidebar from 'App/Shell/LoggedSidebar'
import { Alert } from 'loyal-react'

import { NeedOnboarding } from './NeedOnboarding'
import { SendPhoneToken } from './SendPhoneToken'
import { PasswordNumber } from './PasswordNumber'
import { PasswordNumberConfirm } from './PasswordNumberConfirm'
import { SendMailToken } from './SendMailToken'
import { SucessUnlock } from './SucessUnlock'

const timerDefault = 180

class UnlockUraPassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      needOnboarding: false,
      sendPhoneToken: false,
      passwordNumberPage: false,
      passwordNumberConfirmPage: false,
      emailToken: false,
      sucess: false,
      formReady: false,
      isLoading: false,
      expiredTime: false,
      timeLeft: timerDefault,
      timer: null,
      registeredPhone: '',
      registeredEmail: this.maskEmail(),
      sonarCode: '',
      sonarToken: '',
      resultSonarCode: '',
      passwordNumber: '',
      passwordNumberConfirm: '',
      cognitoToken: '',
      campaingId: this.props.userInfo['custom:campaign_id'],
      error: null,
      errors: {}
    }
  }

  componentDidMount () {
    this.getSonarStatus()
  }

  handleChange = ({ target: { name, value } }) => {
    var reg = /^[0-9]+$/
    if (!reg.test(value)) {
      return
    }

    if (name === 'passwordNumber' || name === 'passwordNumberConfirm') {
      if (!value) {
        this.setState({ [name]: value })
      } else if (!isNaN(value)) {
        this.setState({ [name]: value })
      }
      if (
        name === 'passwordNumberConfirm' &&
        value.toString().length === 6 &&
        value !== this.state.passwordNumber
      ) {
        this.setError('PasswordConfirmValidate', 'As senhas não conferem.')
      } else if (name === 'passwordNumberConfirm' && value.length !== 6) {
        this.setState({ error: null })
      }
    } else {
      this.setState({ [name]: value })
    }
  }

  getSonarStatus = () => {
    this.setState({ isLoading: true })
    const handleSuccess = response => {
      this.setState({ isLoading: false })
      if (response && response.type === 'FETCH_GET_SONAR_STATUS_SUCCESS') {
        const {
          payload: {
            data: { data }
          }
        } = response
        this.setState({
          sendPhoneToken: data.onboardingCompleted,
          needOnboarding: !data.onboardingCompleted,
          registeredPhone: data.phoneNumber
        })
        this.setState({ error: null })
        if (data.onboardingCompleted) {
          this.handleSendSonarPhoneToken()
        }
      } else {
        this.setError('SonarStatus', 'Erro ao buscar status')
      }
    }

    const handleError = () => {
      this.setError('SonarStatus', 'Erro ao buscar status')
      this.setState({ formReady: true, isLoading: false })
    }

    this.props
      .fetchSonarStatus()
      .then(handleSuccess)
      .catch(handleError)
  }

  handleSendSonarPhoneToken = () => {
    this.setState({ isLoading: true })
    const handleSuccess = response => {
      this.setState({ isLoading: false })
      if (response && response.type === 'FETCH_SEND_SONAR_TOKEN_SUCCESS') {
        const {
          payload: {
            data: { data }
          }
        } = response
        this.setState({
          sonarCode: data,
          timeLeft: timerDefault,
          expiredTime: false
        })
        this.startTimer()
        this.setState({ error: null })
      } else {
        this.setError('SonarSendToken', 'Erro ao enviar o token')
      }
      this.setState({ formReady: true })
    }

    const handleError = () => {
      this.setError('SonarSendToken', 'Erro ao enviar o token')
      this.setState({ formReady: true, isLoading: false })
    }

    this.props
      .fetchSendSonarToken()
      .then(handleSuccess)
      .catch(handleError)
  }

  setError = (local, msg) => {
    const { errors } = this.state
    let result = errors
    result[local] = msg
    if (msg) {
      this.setState({
        error: { msg: msg }
      })
    }
    this.setState({
      errors: result
    })
  }

  handleValidateSonarToken = () => {
    this.setState({ isLoading: true })
    const data = {
      documentNumber: this.props.document.value,
      code: this.state.sonarCode,
      token: this.state.sonarToken,
      isLoading: true
    }

    const handleSuccess = response => {
      this.setState({ isLoading: false })
      if (response && response.type === 'FETCH_VALIDATE_SONAR_TOKEN_SUCCESS') {
        const {
          payload: {
            data: { data }
          }
        } = response
        this.setState({
          resultSonarCode: data,
          sendPhoneToken: false,
          passwordNumberPage: true
        })
        clearInterval(this.state.timer)
        this.setState({ error: null })
      } else {
        this.setError('SonarValidToken', 'Token inválido. Tente novamente.')

        this.setState({
          sonarToken: ''
        })
      }
    }

    const handleError = () => {
      this.setError('SonarValidToken', 'Token inválido. Tente novamente.')
      this.setState({ isLoading: false })

      this.setState({
        sonarToken: ''
      })
    }

    this.props
      .fetchValidateSonarToken(data)
      .then(handleSuccess)
      .catch(handleError)
  }

  handleValidatePassword = () => {
    this.setState({ isLoading: true })

    const handleSuccess = response => {
      this.setState({ isLoading: false })
      if (response && response.type === 'FETCH_CHECK_PASSWORD_SUCCESS') {
        const {
          payload: {
            data: { data }
          }
        } = response
        if (data) {
          this.setState({
            passwordNumberPage: false,
            passwordNumberConfirmPage: true
          })
          this.setState({ error: null })
        } else {
          this.setError(
            'PasswordValidate',
            'Senha não segue os requisitos acima.'
          )

          this.setState({
            passwordNumber: ''
          })
        }
      } else {
        this.setError(
          'PasswordValidate',
          'Senha não segue os requisitos acima.'
        )

        this.setState({
          passwordNumber: ''
        })
      }
    }

    const form = {
      PasswordNumber: this.state.passwordNumber,
      DocumentNumber: this.props.document.value
    }
    this.props.fetchCheckPassword(form).then(handleSuccess)
  }

  handleValidatePasswordConfirm = () => {
    this.setState({ isLoading: true })
    const { passwordNumber, passwordNumberConfirm } = this.state
    if (passwordNumber === passwordNumberConfirm) {
      this.handleSendCognitoToken()
      this.setState({ error: null })
    } else {
      this.setError('PasswordConfirmValidate', 'As senhas não conferem.')
      this.setState({
        isLoading: false
      })
    }
  }

  handleSendCognitoToken = () => {
    this.setState({ isLoading: true })
    const handleSuccess = response => {
      this.setState({ isLoading: false })
      if (response && response.type === 'FETCH_SEND_COGNITO_TOKEN_SUCCESS') {
        const {
          payload: {
            data: { data }
          }
        } = response
        if (data) {
          this.setState({
            passwordNumberConfirmPage: false,
            emailToken: true,
            timeLeft: timerDefault,
            expiredTime: false
          })
          this.startTimer()
          this.setState({ error: null })
        } else {
          this.setError(
            'PasswordConfirmValidate',
            'Limite de envio excedido. Tente novamente mais tarde.'
          )
        }
      } else {
        this.setError(
          'PasswordConfirmValidate',
          'Ocorreu um erro ao enviar o token.'
        )
      }
    }

    const handleError = () => {
      this.setError(
        'PasswordConfirmValidate',
        'Ocorreu um erro ao enviar o token.'
      )
      this.setState({ isLoading: false })
    }

    this.props
      .fetchSendCognitoToken()
      .then(handleSuccess)
      .catch(handleError)
  }

  handleUnlockUra = () => {
    this.setState({
      isLoading: true
    })
    const { passwordNumber, resultSonarCode, cognitoToken } = this.state
    const data = {
      passwordNumber: passwordNumber,
      documentNumber: this.props.document.value,
      cognitoToken: cognitoToken,
      sonarToken: resultSonarCode
    }

    const handleSuccess = response => {
      this.setState({ isLoading: false })
      if (response && response.type === 'FETCH_UNLOCK_URA_SUCCESS') {
        const {
          payload: {
            data: { data }
          }
        } = response
        if (data) {
          this.setState({
            emailToken: false,
            sucess: true
          })
          clearInterval(this.state.timer)
          this.setState({ error: null })
        } else {
          this.setError('CognitoResult', 'Token inválido. Tente novamente.')

          this.setState({
            sonarToken: ''
          })
        }
      } else {
        this.setError('CognitoResult', 'Token inválido. Tente novamente.')

        this.setState({
          sonarToken: ''
        })
      }
    }

    const handleError = () => {
      this.setState({ isLoading: false })
      this.setError('CognitoResult', 'Ocorreu um erro ao salvar.')
    }

    this.props
      .fetchUnlockUra(data)
      .then(handleSuccess)
      .catch(handleError)
  }

  maskEmail = () => {
    let email = this.props.userInfo.email
    let maskedEmail = ''
    let idx = 0
    let arroba = email.indexOf('@')
    for (let e of email) {
      if (idx >= 4 && idx < arroba) {
        maskedEmail += '*'
      } else if (idx > arroba && idx < arroba + 3) {
        maskedEmail += '*'
      } else {
        maskedEmail += e
      }
      idx++
    }
    return maskedEmail
  }

  countDown () {
    this.setState({ timeLeft: this.state.timeLeft - 1 })
    if (this.state.timeLeft === 0) {
      clearInterval(this.state.timer)
      this.setState({ expiredTime: true })
    }
  }

  startTimer = () => {
    this.setState({
      timer: setInterval(() => {
        this.countDown()
      }, 1000)
    })
  }

  toSeconds = seconds => {
    return [parseInt((seconds / 60) % 60), parseInt(seconds % 60)]
      .join(':')
      .replace(/\b(\d)\b/g, '0$1')
  }

  closeAlert = () => this.setState({ error: null, success: null })

  render () {
    return (
      <Fragment>
        <Helmet>
          <title>{`Desbloquear senha da URA - ${process.env.REACT_APP_TITLE ||
            ''}`}</title>
        </Helmet>
        <div className='container-fluid px-0 bg-ui-4'>
          <div className='container py-4'>
            <div className='row'>
              <LoggedSidebar selected={this.props.location.pathname} />
              <div className='col-12 col-md-8 mt-0'>
                {this.state.error && this.state.error !== null ? (
                  <Alert
                    isError
                    title={this.state.error.msg}
                    className='pb-2'
                    onClose={this.closeAlert}
                  />
                ) : (
                  ''
                )}
                {this.state.needOnboarding ? (
                  <NeedOnboarding {...this.state} />
                ) : this.state.sendPhoneToken ? (
                  <SendPhoneToken
                    {...this.state}
                    toSeconds={this.toSeconds}
                    handleChange={this.handleChange}
                    handleValidateSonarToken={this.handleValidateSonarToken}
                    handleSendSonarPhoneToken={this.handleSendSonarPhoneToken}
                  />
                ) : this.state.passwordNumberPage ? (
                  <PasswordNumber
                    {...this.state}
                    handleChange={this.handleChange}
                    handleValidatePassword={this.handleValidatePassword}
                  />
                ) : this.state.passwordNumberConfirmPage ? (
                  <PasswordNumberConfirm
                    {...this.state}
                    handleChange={this.handleChange}
                    handleValidatePasswordConfirm={
                      this.handleValidatePasswordConfirm
                    }
                  />
                ) : this.state.emailToken ? (
                  <SendMailToken
                    {...this.state}
                    toSeconds={this.toSeconds}
                    handleChange={this.handleChange}
                    handleUnlockUra={this.handleUnlockUra}
                    handleSendCognitoToken={this.handleSendCognitoToken}
                  />
                ) : this.state.sucess ? (
                  <SucessUnlock {...this.state} />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

UnlockUraPassword.propTypes = {
  location: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  document: PropTypes.object.isRequired,
  fetchSendSonarToken: PropTypes.func,
  fetchValidateSonarToken: PropTypes.func,
  fetchSendCognitoToken: PropTypes.func,
  fetchUnlockUra: PropTypes.func,
  fetchSonarStatus: PropTypes.func,
  fetchCheckPassword: PropTypes.func
}

export default UnlockUraPassword



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/UnlockUraPassword/UnlockUraPassword.js